import * as React from 'react';
import { ArticleHeading4 } from '@cian/ui-kit';

import { SALES_TYPE_ICONS } from '../../../../constants/salesTypeIcons';
import { ESalesType } from '../../../../types/offersData';

import * as styles from './SalesLink.css';

interface ISalesLinkProps {
  type?: ESalesType;
  onClick?(type: ESalesType): void;
  url?: string;
  title: string;
}

export function SalesLink({ onClick, type, url, title }: ISalesLinkProps) {
  const icon = type && SALES_TYPE_ICONS.get(type);

  const handleClick = React.useCallback(() => {
    if (!onClick || !type) {
      return;
    }

    onClick(type);
  }, [onClick, type]);

  return (
    <a className={styles['link']} href={url} onClick={handleClick} data-testid="SalesLink">
      {icon && <div className={styles['icon']}>{icon}</div>}
      <ArticleHeading4 as="h4" color="theme-dark">
        {title}
      </ArticleHeading4>
    </a>
  );
}
